import { bridge } from "../constants"

import { formatDuration } from "./time"

function getEstimatedBridgeTime(isBitcoinFlow = false) {
  if (!isBitcoinFlow)
    return `~ ${formatDuration(bridge.ESTIMATED_ERC20_BRIDGE_TIME, "m' mins'")}`

  const minDuration = formatDuration(
    bridge.ESTIMATED_NATIVE_BTC_BRIDGE_TIME.min,
    "h'",
  )

  const maxDuration = formatDuration(
    bridge.ESTIMATED_NATIVE_BTC_BRIDGE_TIME.max,
    "h' hours",
  )

  return `~ ${minDuration}-${maxDuration}`
}

export default {
  getEstimatedBridgeTime,
}
